export default __webpack_public_path__ + "static/media/x-icon.59f61548.svg";